module.exports = __webpack_public_path__ + "static/media/ARWeiBei-01.25442aa0.svg";